<template>
  <div >
    <!-- <h1 class="title">{{ title }}</h1> -->
    
    
    
    
    
  </div>
</template>

<script>
export default {
  name: 'Verfied_by_site',
  data () {
    return {
      title: 'Verfied_group_by_site page',
      
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/verfied_by_site.vue